import { Box, Typography } from '@mui/material';

// Célula de grade com valor principal e informação complementar abaixo, para reduzir a quantidade de colunas
export function TwoLineCell({ primary, secondary, bold }: { primary?: string; secondary?: string; bold?: boolean }) {
    return (
        <Box sx={{ minWidth: 0, lineHeight: 1.3 }}>
            <Typography variant="body2" fontWeight={bold ? 600 : 400} noWrap>{primary}</Typography>
            {secondary && <Typography variant="caption" color="text.secondary" noWrap component="div">{secondary}</Typography>}
        </Box>
    );
}
